import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Loader } from './../../../components/loader';
import { ProductLineLink } from './shopCaseProductLine';
import { FirstStageModalLink } from './../../order/components/firstStage';
import { getConsiderProductPriceByTypePrice } from '../../../functions/app';
import { Float } from '../../../functions/input-float';
import _ from 'underscore';
import { Button, Divider } from 'antd';

class ShopCase extends Component {
    render() {
        let props = this.props,
            product_total_price_sum = 0;
        _.each(
            props.products,
            (i) =>
                (product_total_price_sum +=
                    Number(i.qty) *
                    getConsiderProductPriceByTypePrice(
                        i,
                        props.point.type_price_json,
                        i.qty,
                        props.user ? props.user.discount : 0
                    ).price_consider)
        );
        return (
            <div className={'shop-case-modal-wrapper'}>
                <div className="modal-scroll shop-case">
                    {props.storeIsFetching ? <Loader /> : null}
                    {props.products.map((item, key) => {
                        return (
                            <Fragment key={key}>
                                <ProductLineLink product={item} />
                                <Divider />
                            </Fragment>
                        );
                    })}
                </div>
                <div
                    className="modal-footer shop-case-footer"
                    style={{
                        background: props.setting.rightModal.footer.background,
                        borderColor:
                            props.setting.rightModal.footer.borderColor,
                    }}
                >
                    <div className="shop-case-total mb-2">
                        <div
                            className="shop-case-total-name"
                            style={{
                                color: props.setting.rightModal.body
                                    .secondColor,
                            }}
                        >
                            Сумма заказа:
                        </div>
                        <div
                            className="shop-case-total-cash"
                            style={{
                                color: props.setting.rightModal.body.color,
                            }}
                        >
                            {Float(product_total_price_sum)} {props.currency}
                        </div>
                    </div>
                    <Button
                        style={{
                            width: '100%',
                            height: '100%',
                            background:
                                props.setting.rightModal.footer.button
                                    .background,
                            color: props.setting.rightModal.footer.button.color,
                            borderColor:
                                props.setting.rightModal.footer.button
                                    .borderColor,
                        }}
                        onClick={props.openFirstStage}
                    >
                        Перейти к оформлению
                    </Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = function mapStateToProps(state) {
    return {
        route: state.appState.route,
        setting: state.appState.setting,
        user: state.authState.user,
        currency: state.pointsState.currency,
        point: state.shopState.order.point,
        products: state.shopState.shopCase.products,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        closeModal: function () {
            dispatch({
                type: 'closeRightModal',
            });
        },
        destroyProduct: function (product_id) {
            dispatch({
                type: 'destroy_product',
                product_id: product_id,
            });
        },
        setProductQty: function (product_id, qty) {
            dispatch({
                type: 'set_product_qty',
                product_id: product_id,
                qty: qty,
            });
        },
        clearShopCase: function () {
            dispatch({
                type: 'clear_shop_case',
            });
        },
        openFirstStage: () => {
            dispatch({
                type: 'openRightModal',
                HeadItem: ['Оформление заказа'],
                children: <FirstStageModalLink />,
                onClose: () => {
                    dispatch({ type: 'closeRightModal' });
                },
            });
        },
        dispatch,
    };
};

export const ShopCaseLink = connect(
    mapStateToProps,
    mapDispatchToProps
)(ShopCase);
